export default __webpack_public_path__ + "static/O0124-ab159cbb4cde8748085eb1b1fc1eb0f9.png";